import { withTranslation } from "next-i18next";
import { useRouter } from "next/compat/router";
import { useFormatDate } from "@hooks/use-format-date";
import ProductGlobalRating from "../Shared/ProductGlobalRating";

function ProductRecentCommentCard({ review, t }) {
  const router = useRouter();
  const formatDate = useFormatDate();
  const { locale } = router;

  return (
    <div className="product-recent-comment-card">
      <div className="d-flex flex-row w-100 justify-content-between mb-3">
        <ProductGlobalRating
          globalRating={review.rating}
          withRatingsCount={false}
          size="20px"
        />

        <p className="mb-0 text-gray font-size-sm">{formatDate(review.user_modified_at)}</p>
      </div>
      <div className="d-flex flex-column justify-content-between flex-grow-1">
        <p className="comment text-gray">
          {t("product:review_comment", { comment: review.localized_comment })}
        </p>

        {locale !== review.lang && (
          <p className="font-size-sm text-gray fst-italic mt-3 mb-0 text-end">
            {t(`product:translated_from.${review.lang}`)}
          </p>
        )}
      </div>
    </div>
  );
}

export default withTranslation("product")(ProductRecentCommentCard);
